module.exports = __webpack_public_path__ + "static/media/refunded_icon_150.4cf40227.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/old/refunded_icon_150.png
// module id = 584
// module chunks = 0